import api from '@/apis/sa/sASaleInvoiceStatusAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('sASaleInvoiceStatus', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sa_sale_invoice_status',
    field: {
      key: 'transaction_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * cập nhật trạng thái gửi hóa đơn
   * TTLONG 21/09/2022
   * @param {*} context
   * @param {*} param
   */
  async updateSendEmailStatus(context, param) {
    return await api.updateSendEmailStatus(param);
  },
  /**
   * Lấy dữ liệu columns của entity
   * TTLONG 23/09/2022
   * @param {*} context
   * @param {*} param
   */
  async getColumnData(context, param) {
    return await api.getColumnData(param);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
